import { overlay } from '@vaadin/vaadin-lumo-styles/mixins/overlay.js';
import { registerStyles } from '@vaadin/vaadin-themable-mixin/vaadin-themable-mixin.js';

registerStyles('vaadin-overlay', overlay, { moduleId: 'lumo-vaadin-overlay' });
